import React from 'react'
import { colours } from '../Styles';
import styled from 'styled-components';
import waterdrops from '../img/waterdrops.png';

function MissionStatementStrip() {
    const { light } = colours;
    const MissionStatementStrip = styled.div`
        width: 100%;
        min-height: 250px;
        background-image: url(${waterdrops});
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        .overlay {
            width: 100%;
            height: 250px;
            position: absolute;
            background: rgba(0,0,0,0.7);
        }
        p {
            width: 60%;
            font-weight: 200;
            font-size: 16px;
            font-family: Montserrat, sans-serif;
            color: ${light};
            z-index: 1;
        }
        @media only screen and (max-width: 600px) {
            p {
                width: 80%;
            }
        }
    `;
    return  (
        <MissionStatementStrip>
            <div className="overlay"></div>
            <p>At Precision Detail we pride ourselves in providing a premium service to clients through excellent customer service and a true passion for auto care. We understand the need for ensuring a service is completed thoroughly, that’s why Precisions’ operates on a “no-shortcuts” taken approach – emphasizing the detail in auto detailing.</p>
            {/* {props.missionStatement} */}
        </MissionStatementStrip>
    )
}

export default MissionStatementStrip;